import geprek from  '../assets/geprek.svg'

export const carts = [
    {
        name : 'Paket Geprek',
        price: 'Rp. 15.000 ',
        image: geprek,
        qty: 1      
    },
    {
        name : 'Paket Geprek',
        price: 'Rp. 15.000 ',
        image: geprek,
        qty: 1      
    },
    {
        name : 'Paket Geprek',
        price: 'Rp. 15.000 ',
        image: geprek,
        qty: 1      
    },

]